import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonAnimation } from '../../skeleton-loader.types';

@Component({
  selector: 'cm-skeleton-page',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-page.component.html',
  styleUrl: './skeleton-page.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonPageComponent {
  public readonly animation = input<SkeletonAnimation>('shimmer');
}
